import { useEffect } from "react";
import Modal from "../ui/Modal";
import { ClockIcon } from "../ui/Icons";

interface ISessionExpiredModalProps {
  title: string;
  subtitle?: string;
  message: string;
  confirmLabel: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel?: () => void;
  countdown?: number;
  setCountdown?: (value: number) => void;
}

export default function SessionExpiredModal({
  title,
  subtitle,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  countdown,
  setCountdown,
}: ISessionExpiredModalProps) {
  // cuenta regresiva visible hasta que el vigia decide cerrar la sesion
  useEffect(() => {
    if (countdown === undefined || !setCountdown || countdown <= 0) return;

    const interval = setInterval(() => setCountdown(countdown - 1), 1000);
    return () => clearInterval(interval);
  }, [countdown, setCountdown]);

  return (
    <Modal
      title={title}
      footer={
        <>
          {onCancel && cancelLabel && (
            <button type="button" className="btn btn--ghost" onClick={onCancel}>
              {cancelLabel}
            </button>
          )}
          <div className="modal__foot-spacer" />
          <button type="button" className="btn btn--primary" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </>
      }
    >
      <div className="session">
        <div className="session__icon">
          <ClockIcon size={22} />
        </div>

        {subtitle && <p className="session__text">{subtitle}</p>}

        {countdown !== undefined && (
          <p className="session__count">
            {String(Math.floor(countdown / 60)).padStart(2, "0")}:
            {String(countdown % 60).padStart(2, "0")}
          </p>
        )}

        <p className="session__text">{message}</p>
      </div>
    </Modal>
  );
}
